module.exports = __webpack_public_path__ + "img/1.e7395ca3.png";